import { styled } from '@styles/stitches';
import { Button } from '@versumstudios/ui';

export const Container = styled('div', {
  [`& ${Button}`]: {
    display: 'flex',
    alignItems: 'center',
    padding: '$space$4 0',
    backgroundColor: 'transparent',
    border: 'none',

    i: {
      fontSize: 16,
      marginRight: 4,
      color: '$secondaryFill',
    },
  },

  variants: {
    selected: {
      true: {
        [`& ${Button}`]: {
          i: {
            color: '$red', // primaryFill
          },
        },
      },
    },
  },
});
